
import React from 'react';

interface UpdateAcknowledgmentProps {
  onAcknowledge: () => void;
  lastUpdateCheck: number;
  setLastUpdateCheck: (timestamp: number) => void;
  _lastUpdateTimestamp: number;
}

const UpdateAcknowledgment: React.FC<UpdateAcknowledgmentProps> = ({ 
  onAcknowledge, 
  lastUpdateCheck, 
  setLastUpdateCheck,
  _lastUpdateTimestamp 
}) => {
  // This component is now passive, not actively doing anything
  React.useEffect(() => {
    // Set update as acknowledged
    window.__UPDATE_ACKNOWLEDGED__ = true;
    
    // Simply call the acknowledge handler once
    setLastUpdateCheck(_lastUpdateTimestamp);
    onAcknowledge();
  }, [_lastUpdateTimestamp, onAcknowledge, setLastUpdateCheck]);
  
  return null; // This is a non-visual component
};

export default UpdateAcknowledgment;
